// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Translations
import { withTranslation } from "react-i18next";
// Infrastructure
import { BillingAPI } from "views/Order/infrastructure";
// Vendor
import { showNotify } from "vendor/application/disptach";
// Application
import { getBillingBody, sortBy, isValidEmail } from "vendor/application";
import { ElementsHandleAPI } from "vendor/application/handleMethods";
// Components
import BillingView from "components/Cards/cardBillingView";
import BillingSave from "components/Cards/cardBillingSave";
import "views/Billing/styles/index.scss";

class Billing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      billing: "",
      allCountries: "",
      province: "",
      countries: "",
      view: true
    };
  }

  componentDidMount = () => {
    const { user } = this.props.data;
    if (user.username === "gonzalo.berrmejo@makro.es") {
      this.props.history.push("/users");
    } else {
      this.getBilling();
    }
  };

  // update element state
  updateElement = (e, type) => {
    const { billing } = this.state;
    const obj = new ElementsHandleAPI(billing, e.target.value, type);
    const res = obj.updateObj();

    this.setState({ billing: res });
  };

  getBilling = async () => {
    const { access, user } = this.props.data;
    try {
      const obj = new BillingAPI(user.account_id, access, this.props, null);
      let res = await obj.get_billing();
      this.setState({ billing: res });
    } catch (err) {
      this.setState({ billing: getBillingBody(), view: false, create: true });
    }
    this.getCountries();
  };

  handleBilling = (method) => {
    const { billing } = this.state;

    if (isValidEmail(billing.email)) {
      switch (method) {
        case "POST":
          this.postBilling();
          break;
        case "PUT":
          this.putBilling();
          break;
      }
    } else {
      var data = {
        message: "email_not_valid",
        from: "billing",
        severity: "error"
      };
      this.props.dispatch(showNotify(data));
    }
  };

  postBilling = async () => {
    const { access, user } = this.props.data;
    try {
      const obj = new BillingAPI(
        user.account_id,
        access,
        this.props,
        this.state.billing
      );
      let res = await obj.post_billing();
      this.setState({ billing: res, create: false, view: true });
    } catch (err) {
      var data = { message: err, from: "billing", severity: "error" };
      this.props.dispatch(showNotify(data));
    }
  };

  putBilling = async () => {
    const { access, user } = this.props.data;
    try {
      const obj = new BillingAPI(
        user.account_id,
        access,
        this.props,
        this.state.billing
      );
      await obj.put_billing(this.state.billing.id);
      this.setState({ view: true });
    } catch (err) {
      var data = {
        message: err.responseJSON.message,
        from: "order",
        severity: "error"
      };
      this.props.dispatch(showNotify(data));
    }
  };

  updateCountry = (e) => {
    this.state.billing.country = e;

    this.handleCountries(this.state.countries);

    this.setState({ billing: this.state.billing });

    if (this.state.statusBilling === "put") {
      this.handleBilling();
    }
  };

  updateProvince = (e) => {
    this.state.billing.province = e;

    this.handleCountries(this.state.countries);

    this.setState({ billing: this.state.billing });

    if (this.state.statusBilling === "put") {
      this.handleBilling();
    }
  };

  getCountries = async () => {
    const { access } = this.props.data;
    try {
      const obj = new BillingAPI(null, access, this.props, null);
      let res = await obj.get_countries();
      this.handleCountries(res);
    } catch (err) {}
  };

  handleCountries = (data) => {
    var c = [],
      p = [],
      sp = false,
      countries;

    if (this.state.allCountries) {
      countries = this.state.allCountries;
    } else {
      countries = data;
      this.setState({ allCountries: data });
    }

    countries.forEach((country) => {
      if (!sp || country.country !== "Spain") {
        c.push(country);
        sp = true;
      }
      if (country.country === "Spain") {
        p.push(country);
      }
    });

    this.setState({ province: sortBy(p, "province"), countries: c });
  };

  toggleVisibility = () => {
    this.setState({ view: !this.state.view });
  };

  render() {
    const { t } = this.props;
    const { billing, view, allCountries, province, countries, create } =
      this.state;
    return (
      billing && (
        <div className="man-billing">
          <div>
            <div>
              <div className="man-actions">
                <span className="title">{t("billing_information_title")}</span>
                {view ? (
                  <button
                    id={"edit_btn_billing"}
                    className="btn btn-primary"
                    onClick={() => this.toggleVisibility()}
                  >
                    {t("inputs:button.edit")}
                  </button>
                ) : (
                  <button
                    id={"save_btn_billing"}
                    className="btn btn-primary"
                    onClick={() =>
                      this.handleBilling(`${create ? "POST" : "PUT"}`)
                    }
                  >
                    {t("inputs:button.save")}
                  </button>
                )}
              </div>
              <div className={`man-content ${view ? "view" : "save"}`}>
                {view ? (
                  <BillingView billing={billing} />
                ) : (
                  <BillingSave
                    billing={billing}
                    updateElement={this.updateElement}
                    updateCountry={this.updateCountry}
                    updateProvince={this.updateProvince}
                    province={province}
                    countries={countries}
                    allCountries={allCountries}
                  />
                )}
              </div>
            </div>
          </div>
          <div></div>
        </div>
      )
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state
  };
};

const connect_ = connect(mapStateToProps)(Billing);

export default withTranslation(["billing", "inputs"])(withRouter(connect_));
